import { Step } from './ProgressSteps.components.styles';
import type { StepProps } from './ProgressSteps.components.d';
import { ResponsiveFloraTypography } from 'ui/components/primitives';

const StepBase = ({ active, children, completed, last, onClick, size, title }: StepProps) => (
  <Step.Component
    data-active={active}
    data-completed={completed}
    data-last={last}
    data-testid="step"
  >
    <Step.Content>
      <Step.ButtonIcon
        aria-label={`Etapa ${title}`}
        radius="pill"
        data-size="small"
        size={size}
        hierarchy="tertiary"
        has="onlyIcon"
        icon={children}
        data-button-step
      />

      <Step.Title data-active={active}>
        <ResponsiveFloraTypography
          fontSize="bodySmallStandard"
          fontWeight={active ? 'bold' : 'regular'}
        >
          {title}
        </ResponsiveFloraTypography>
      </Step.Title>
    </Step.Content>
  </Step.Component>
);

export default StepBase;
